/* eslint-disable import/no-unresolved */
import {
  KlevuConfig,
  KlevuFetch,
  KlevuDomEvents,
  KlevuEvents,
  search,
  sendSearchEvent,
  listFilters,
  applyFilterWithManager,
  FilterManager,
} from 'https://cdn.skypack.dev/-/@klevu/core@v5.2.3-HNRf1HrJ9AqvnoHcX5mg/dist=es2019,mode=imports,min/optimized/@klevu/core.js'
const { debounce } = window.BAO.Utils

KlevuConfig.init({
  apiKey: `${window.theme.klevu.apiKey}`,
  url: `https://${window.theme.klevu.url}/cs/v2/search`,
})

class KlevuSearch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.searchTerm = this.getQueryParam('q')

    this.manager = new FilterManager()

    this.sorting = 'RELEVANCE'

    this.onPerformSearch(this.sorting)
  }

  setupListeners () {
    super.setupListeners()

    this.loadResults = this.loadResults.bind(this)
    this.setupResults = this.setupResults.bind(this)
    this.handleFilterUpdate = this.handleFilterUpdate.bind(this)
    this.generateFilterMarkup = this.generateFilterMarkup.bind(this)
    this.generateSelectedFilterMarkup =
      this.generateSelectedFilterMarkup.bind(this)
    this.handleSortingUpdate = this.handleSortingUpdate.bind(this)

    this.onClick = this.onClick.bind(this)
    this.appendNextPage = this.appendNextPage.bind(this)

    this.onPerformSearch = debounce(this.onPerformSearch.bind(this), 300)

    this.els?.button?.element.addEventListener('click', this.onClick)

    this.handleOptionTrigger = this.handleOptionTrigger.bind(this)

    this.listeners.add(document, 'click', this.handleOptionTrigger)

    this.handleOptionRemove = this.handleOptionRemove.bind(this)

    this.listeners.add(document, 'click', this.handleOptionRemove)

    this.externalEls.sort.elements.forEach((sortingEl) => {
      this.listeners.add(sortingEl, 'click', this.handleSortingUpdate)
    })

    this.onProductClick = this.onProductClick.bind(this)

    document.addEventListener(
      KlevuDomEvents.FilterSelectionUpdate,
      this.handleFilterUpdate,
    )
  }

  onProductClick (event) {
    const product = event.target.closest('[data-klevu-search-product]')

    const productClickData = {
      product: {
        id: `${product.dataset.productId}`,
        name: `${product.dataset.productName}`,
        url: `${product.dataset.productUrl}`,
      },
      searchTerm: `${this.searchTerm}`,
    }

    KlevuEvents.searchProductClick(productClickData)
  }

  getQueryParam (param) {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(param)
  }

  onPerformSearch () {
    this.loadResults(this.sorting)
  }

  handleFilterUpdate () {
    this.els.button.element.dataset.index = '1'
    this.loadResults(this.sorting)
  }

  handleSortingUpdate (event) {
    const selectedValue = event.target.dataset.value

    this.externalEls.sort.elements.forEach((sortingEl) => {
      sortingEl.setAttribute('aria-pressed', false)
    })

    event.target.setAttribute('aria-pressed', true)

    this.els['sort-value'].element.innerText = event.target.innerText

    this.sorting = selectedValue
    this.els.button.element.dataset.index = '1'
    this.loadResults(this.sorting)
  }

  handleDisplayNoResults () {
    const headerEl = this.externalEls.header?.element
    const footerEl = this.els.footer?.element
    const searchEl = this.externalEls.search?.element
    const sectionEls = this.externalEls['section-no-results']?.elements

    if (headerEl) {
      headerEl.classList.add('tmp-Search_Header-textCenter')
    }

    if (footerEl) {
      footerEl.setAttribute('aria-hidden', true)
    }

    if (searchEl) {
      searchEl.setAttribute('aria-hidden', false)
    }

    if (sectionEls) {
      sectionEls.forEach((item) => {
        item.setAttribute('aria-hidden', 'false')
      })
    }

    window.dispatchEvent(new Event('resize'))
  }

  async loadResults (sorting) {
    const result = await KlevuFetch(
      search(
        this.searchTerm,
        {
          id: 'search', // not required as for default it's the same.
          fields: ['url'],
          limit: 12, // This controls the amount of results returned in a single fetch for the searchTerm
          sort: sorting,
        },
        listFilters({
          filterManager: this.manager, // pass manager to list filters so that it will be populated by results
        }),
        applyFilterWithManager(this.manager),
        sendSearchEvent(),
      ),
    )

    const recordsResults = result.queriesById('search')
    const records = result.queriesById('search')?.records
    const recordsTotal = result.queriesById('search').meta.totalResultsFound

    this.totalResultsShowing = records.length
    this.recordsTotal = recordsTotal

    if (recordsTotal === 0) {
      this.handleDisplayNoResults()
    }

    this.els.total.elements.forEach((totalEl) => {
      if (this.totalResultsShowing > 1) {
        totalEl.innerText = `Showing ${this.totalResultsShowing} of ${this.recordsTotal} items`
      } else {
        totalEl.innerText = `Showing ${this.totalResultsShowing} of ${this.recordsTotal} item`
      }

      totalEl.setAttribute('data-amount', this.totalResultsShowing)
    })

    this.externalEls.filters.element.innerHTML = this.generateFilterMarkup(
      this.manager.options,
    )

    this.els['facet-count'].element.innerText =
      this.manager.selectedFilters().length

    this.els['selected-filters'].element.innerHTML =
      this.generateSelectedFilterMarkup(this.manager.selectedFilters())

    if (records) {
      this.setupResults(records, recordsTotal)
    }

    this.recordsResults = recordsResults
    this.recordsTotalIndex0 = recordsTotal - 1

    this.els.button.element.setAttribute(
      'aria-hidden',
      recordsResults.hasNextPage() ? 'false' : 'true',
    )

    if (recordsResults.hasNextPage()) {
      if (!this.els.button.element.dataset.index) {
        this.els.button.element.dataset.index = '1'
      }
    }

    this.setAttribute('aria-busy', 'false')
  }

  handleOptionTrigger (event) {
    const optionTrigger = event.target.closest(
      '[data-klevu-search-el="option"]',
    )
    if (!optionTrigger) return

    this.manager.toggleOption(optionTrigger.name, optionTrigger.value)
  }

  handleOptionRemove (event) {
    const optionRemove = event.target.closest(
      '[data-klevu-search-el="remove"]',
    )
    if (!optionRemove) return

    this.manager.deselectOption(optionRemove.name, optionRemove.value)
  }

  generateFilterMarkup (filters) {
    return filters
      .map((filterEl) => {
        const optionsMarkup = filterEl.options
          .map(
            (option, index) => `
                  <li class="drw-DrawerFilter_Item">
                    <label
                      class="drw-DrawerFilter_Label"
                      for="${filterEl.key}-${index}"
                    >
                      <input
                        class="drw-DrawerFilter_Checkbox"
                        type="checkbox"
                        name="${filterEl.key}"
                        value="${option.value}"
                        id="${filterEl.key}-${index}"
                        ${option.selected === true ? 'checked' : ''}
                        data-klevu-search-el="option"
                      >

                      <span class="drw-DrawerFilter_CheckboxIcon">
                        <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.294 1.604a.7.7 0 0 1 .002.99l-5.668 5.7a.7.7 0 0 1-.992 0L.704 6.35a.7.7 0 0 1 .992-.988l1.436 1.444 5.172-5.2a.7.7 0 0 1 .99-.003Z" fill="currentColor"/>
                        </svg>
                      </span>

                      <span class="drw-DrawerFilter_CheckboxText">
                        <span class="drw-DrawerFilter_CheckboxTitle fz-15_130">
                          ${option.value}
                        </span>
                      </span>
                    </label>
                  </li>
        `,
          )
          .join('')

        return `
            <div
              class="drw-DrawerFilters_Item"
              aria-expanded="false"
              data-filter-accordions-el="item"
              aria-expanded="false"
              role="treeitem"
            >
              <div
                class="drw-DrawerFilter"
              >
                <button
                  type="button"
                  class="drw-DrawerFilter_Trigger fz-20_130"
                  data-filter-accordions-el="trigger"
                >
                  <span class="drw-DrawerFilter_FilterLabel">
                    ${filterEl.label}
                  </span>

                  <div class="drw-DrawerFilter_TriggerIcon">
                    <span class="drw-DrawerFilter_TriggerIconPlus">
                      <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                        <path fill="currentColor" d="M4.5.5h1v9h-1v-9Z"/>
                        <path fill="currentColor" d="M.5 4.5h9v1h-9v-1Z"/>
                      </svg>
                    </span>
        
                    <span class="drw-DrawerFilter_TriggerIconMinus">
                      <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M.5 4.5h9v1h-9v-1Z" fill="currentColor"/>
                      </svg>
                    </span>
                  </div>
                </button>

                <div
                  class="drw-DrawerFilter_Content"
                  data-filter-accordions-el="item"
                  aria-expanded="false"
                  role="treeitem"
                >
                  <div class="drw-DrawerFilter_Body" data-filter-accordions-el="content">
                    <ul class="drw-DrawerFilter_List">
                      ${optionsMarkup}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
        `
      })
      .join('')
  }

  generateSelectedFilterMarkup (selectedFilters) {
    return selectedFilters
      .map((selectedFilterEl) => {
        return `
          <button type="button" class="tmp-Search_SelectedFilterButton fz-13_130" name="${selectedFilterEl.key}" value="${selectedFilterEl.value}" data-klevu-search-el="remove">
            ${selectedFilterEl.value}
            <span class="tmp-Search_SelectedFilterIcon">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path fill="currentColor" d="m14.338 4.338.99.99-9.837 9.837-.99-.99z"/><path fill="currentColor" d="m15.336 14.338-.99.99L4.509 5.49l.99-.99z"/>
              </svg>
            </span>
          </button>
        `
      })
      .join('')
  }

  async onClick () {
    this.setAttribute('aria-busy', 'true')

    const currentIndex = parseInt(this.els.button.element.dataset.index, 10)

    await this.fetchMore(this.recordsResults, currentIndex)

    this.els.button.element.dataset.index = currentIndex + 1

    this.els.button.element.setAttribute(
      'aria-hidden',
      this.recordsTotalIndex0 === this.resultsOffset ? 'true' : 'false',
    )
  }

  async fetchMore (recordsResults, pageIndex) {
    const nextRes = await recordsResults.getPage({
      pageIndex,
    })

    const nextRecords = nextRes.apiResponse.queryResults[0].records

    this.resultsOffset = nextRes.apiResponse.queryResults[0].meta.offset

    this.totalResultsShowing = this.totalResultsShowing + nextRecords.length

    this.els.total.elements.forEach((totalEl) => {
      if (this.totalResultsShowing > 1) {
        totalEl.innerText = `Showing ${this.totalResultsShowing} of ${this.recordsTotal} items`
      } else {
        totalEl.innerText = `Showing ${this.totalResultsShowing} of ${this.recordsTotal} item`
      }

      totalEl.setAttribute('data-amount', this.totalResultsShowing)
    })

    this.appendNextPage(nextRecords)

    this.setAttribute('aria-busy', 'false')

    window.BAO.dispatchEvent(window.BAO.EVENTS.PRODUCT_GRID.RENDERED)
  }

  async appendNextPage (records) {
    const productCardHTML = await this.getAllProductCardHTML(records)
    this.els.results.element.insertAdjacentHTML('beforeend', productCardHTML)

    this.attachProductClickListeners()
  }

  async setupResults (records, recordsTotal) {
    const productCardHTML = await this.getAllProductCardHTML(records)
    this.els.results.element.innerHTML = productCardHTML

    this.externalEls.text.element.innerHTML = `Showing ${recordsTotal} results for <span>'${this.searchTerm}'</span>`

    window.BAO.dispatchEvent(window.BAO.EVENTS.PRODUCT_GRID.RENDERED)

    this.attachProductClickListeners()
  }

  attachProductClickListeners () {
    const productEls = this.els.results.element.querySelectorAll(
      '[data-klevu-search-product]',
    )

    productEls.forEach((productEl) => {
      productEl.addEventListener('click', this.onProductClick)
    })
  }

  async getAllProductCardHTML (records) {
    const productCardHTML = await Promise.all(
      records.map(
        async (product, index) => await this.getProductCardHTML(product, index),
      ),
    )
    return productCardHTML.filter(Boolean).join('')
  }

  async getProductCardHTML (product, index) {
    const productUrl = product.url.replace(
      '/products/',
      `${window.Shopify.routes.root}products/`,
    )

    return window.BAO.sectionRenderer
      .fetchSingle('search-product-card', `${productUrl}`)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('article')

        if (myself) {
          return `<div class="tmp-Search_Result">${myself.outerHTML}</div>`
        }
      })
      .catch(() => {
        return null
      })
  }
}

if (!customElements.get('klevu-search')) {
  customElements.define('klevu-search', KlevuSearch)
}
